import moment from "moment";
import { Link } from "react-router-dom";
import { isTaskOverdue, NotificationTaskType } from "services/tasks";
import { getUserFullName } from "services/util";
import TalaeraRoutes from "components/routes/TalaeraRoutes";
import { Task } from "model/task";

// eslint-disable-next-line no-shadow
enum TaskTypeName {
  FEEDBACK = "Feedback",
  PLAN = "Lesson plan",
  DEFAULT = "Notification",
}

interface TaskListItemProps {
  item: Task;
  closeDetails: () => void;
}

export function TaskListItem({ item, closeDetails }: TaskListItemProps) {
  const getTaskTypeName = (task: Task) => {
    if (task.type === NotificationTaskType.FEEDBACK) {
      return TaskTypeName.FEEDBACK;
    } else if (task.type === NotificationTaskType.PLAN) {
      return TaskTypeName.PLAN;
    }
  };

  const getTaskTitle = (task: Task) => {
    return (
      getTaskTypeName(task) +
      " for " +
      getUserFullName(task.session ? task.session.user : task.user)
    );
  };

  const getTaskDescription = (task: Task) => {
    let description = null;
    if (task.type === NotificationTaskType.FEEDBACK) {
      description =
        "Session feedback for lesson with " +
        getUserFullName(task.session?.user) +
        " on " +
        moment(task.session?.scheduled).format("MMM D [@] h:mm a") +
        " is ";
    } else if (task.type === NotificationTaskType.PLAN) {
      description = "Lesson plan for " + getUserFullName(task.user) + " is ";
    }
    if (isTaskOverdue(task)) {
      description += moment(task.due_date).fromNow(true) + " overdue.";
    } else {
      description += " due " + moment().to(task.due_date) + ".";
    }
    return description;
  };

  const getAction = (task: Task) => {
    let toPath = null;
    let actionName = null;
    if (task.type === NotificationTaskType.FEEDBACK) {
      toPath = TalaeraRoutes.buildSessionFeedbackEditPath(task.session?.id);
      actionName = "Give Feedback";
    } else if (task.type === NotificationTaskType.PLAN) {
      toPath = TalaeraRoutes.buildStudentDetailsPath(task.user?.id);
      actionName = "Create Lesson Plan";
    }
    if (toPath && actionName) {
      return (
        <Link className="btn" onClick={closeDetails} to={toPath}>
          {actionName}
        </Link>
      );
    }
    return null;
  };

  return (
    <div className={"notification-list-item" + (isTaskOverdue(item) ? " overdue" : "")}>
      <div className="item-header">
        {getTaskTypeName(item)}
        <span>•</span>
        {moment(item.scheduled).fromNow()}
      </div>
      <div className="item-title">{getTaskTitle(item)}</div>
      <div className="item-description">{getTaskDescription(item)}</div>
      <div className="actions">{getAction(item)}</div>
    </div>
  );
}
